import __var_0__ from '@stdlib/vendor/debug.js';
import __var_1__ from '@stdlib/assert/contains';
import __var_2__ from './chart_types.json';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var logger = __var_0__;
var contains = __var_1__;
var CHART_TYPES = __var_2__;


// VARIABLES //

var debug = logger( 'sparkline:unicode:set:type' );


// MAIN //

/**
* Sets the sparkline chart type.
*
* @private
* @param {string} type - chart type
* @throws {TypeError} must be a supported chart type
*/
function set( type ) {
	/* eslint-disable no-invalid-this */
	if ( !contains( CHART_TYPES, type ) ) {
		throw new TypeError( 'invalid value. `type` must be one of `[' + CHART_TYPES.join( ', ' ) + ']`. Value: `' + type + '`.' );
	}
	if ( type !== this._type ) {
		debug( 'Current value: %s.', this._type );

		this._type = type;
		debug( 'New value: %s.', this._type );

		this.emit( 'change' );
	}
}


// EXPORTS //
export default set;
